export default __webpack_public_path__ + "static/media/Facebook.f4c2c7c2.svg";